module.exports = __webpack_public_path__ + "media/images/lp/1/donation4-title-sp-1260166ccdaec4252a6716a8f3f0580e.png";